type PaymentError = {
  code: string
  message: string
}

export const isPaymentError = (error: unknown): error is PaymentError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    'message' in error
  )
}
